export const GET_CASENOTE_DATA = "GET_CASENOTE_DATA"